module.exports = __webpack_public_path__ + "media/images/riders/small/WYN_MASTERS-38a21db1d0dd7e8fb1b272766c4ab107.png";